module.exports = __webpack_public_path__ + "img/cm_person5.baae431e.jpg";